import React, { useRef, useEffect, useCallback } from 'react';
import { gsap } from '../../../../gsap';
import CopyWithBar from '../../../Common/CopyBlocks/CopyWithBar';
import './Torso.scss';

function ContemporaryTorso({ screenWidth }) {
  const contemporaryTorsoSection = useRef();
  const contemporaryTorsoCanvas = useRef();
  const contemporaryTorsoLower = useRef();
  const contemporaryTorsoAnimation = useRef();
  const images = useRef([]);
  const ratio = useRef();
  const copyData =
    'In 2019, what would have been the first all-female spacewalk was canceled because the ISS did not have enough medium-sized HUT units ready.';

  const playOnScroll = useCallback(() => {
    ratio.current = 1.77;
    images.current = [];
    // set canvas properties
    const canvas = contemporaryTorsoCanvas.current.getContext('2d');
    // Set the size of the canvas
    contemporaryTorsoCanvas.current.width =
      screenWidth > 480 ? Math.min(window.innerWidth * 0.3, 486) : window.innerWidth;
    contemporaryTorsoCanvas.current.height = contemporaryTorsoCanvas.current.width * ratio.current;

    // Count the frames and set the path to the images
    const frameCount = 32;
    const currentFrame = (index) =>
      `https://morgan-stanley-creating-space-cdn.s3.amazonaws.com/contemporary/torso/EMU_TORSO${(
        index + 1
      )
        .toString()
        .padStart(2, '0')}.png`;
    // Set start frame

    const torso = {
      frame: 1
    };

    // Go through frames from start to finish
    const torsoAnim = gsap.timeline({
      scrollTrigger: {
        trigger: contemporaryTorsoAnimation.current,
        start: 'top 50%',
        end: 'bottom bottom',
        scrub: 1
      }
    });

    if (screenWidth < 481) {
      for (let i = 0; i < frameCount; i++) {
        const img = new Image();
        img.src = currentFrame(i);
        images.current.push(img);
      }
    } else {
      for (let i = 0; i < frameCount; i++) {
        const img = new Image();
        img.src = currentFrame(i);
        images.current.push(img);
      }
    }

    torsoAnim.add('start').to(
      torso,
      {
        frame: frameCount - 1,
        snap: 'frame',
        duration: 3,
        ease: 'linear',
        onUpdate: render
      },
      'start'
    );

    images.current[0].onload = render;

    function render() {
      canvas.clearRect(
        0,
        0,
        contemporaryTorsoCanvas.current.width,
        contemporaryTorsoCanvas.current.height
      );
      canvas.drawImage(
        images.current[torso.frame],
        0,
        0,
        contemporaryTorsoCanvas.current.width,
        contemporaryTorsoCanvas.current.height
      );
    }
  }, [screenWidth, images]);

  useEffect(() => {
    playOnScroll();
  }, [screenWidth, playOnScroll]);

  return (
    <section className="torso torso-contemporary" ref={contemporaryTorsoSection}>
      <div className="torso__upper torso__upper-contemporary">
        <h3 className="torso__upper__title">
          On the International Space Station, HUT units are currently only available in medium,
          large, and extra-large.
        </h3>
        <p className="torso__upper__copy torso__text__copy-contemporary">
          In a 2003 NASA study, eight out of 25 female astronauts indicated that medium suits are
          too large for them to effectively work in.
        </p>
        <div className="torso__textWBar torso__textWBar-desktop" ref={contemporaryTorsoLower}>
          <CopyWithBar copyData={copyData} />
        </div>
      </div>

      <div
        className="torso__animation torso__animation-contemporary"
        ref={contemporaryTorsoAnimation}
      >
        <canvas className="torso__animation__canvas" ref={contemporaryTorsoCanvas} />
      </div>

      <div className="torso__textWBar torso__textWBar-mobile" ref={contemporaryTorsoLower}>
        <CopyWithBar copyData={copyData} />
      </div>
    </section>
  );
}

export default ContemporaryTorso;
